@if (!file) {
  <button
    mat-raised-button
    type="button"
    (click)="openFileBrowser()"
    class="imageButton"
    >
    <mat-icon>picture_as_pdf</mat-icon> <mat-icon>add_a_photo</mat-icon> Kies een bestand
  </button>
}
@if (file) {
  <div
    fxLayout="row"
    fxLayoutAlign="start start"
    fxLayoutGap="10px"
    class="document-upload"
    >
    <mat-card appearance="outlined" fxFlex="40%">
      <mat-card-content>
        @if (file.name.endsWith('pdf')) {
          <mat-icon matListItemIcon>picture_as_pdf</mat-icon>
          }@if (!file.name.endsWith('pdf')) {
          <mat-icon matListItemIcon>add_a_photo</mat-icon>
        }
        {{ file.name }}
        <button mat-icon-button (click)="resetForm()">
          <mat-icon>delete</mat-icon>
        </button>
      </mat-card-content>
    </mat-card>
    <mat-form-field fxFlex="40%">
      <input matInput placeholder="Label" [formControl]="nameForm" />
      <mat-hint> bijvoorbeeld: "Notulen Beleids en begrotingsALV" </mat-hint>
    </mat-form-field>
    <button
      mat-raised-button
      fxFlex="20%"
      [disabled]="!nameForm.valid"
      (click)="uploadFile()"
      >
      Opslaan
    </button>
  </div>
}
<div class="pdf_table mat-elevation-z8">
  <table mat-table #table [dataSource]="dataSource" matSort>
    <ng-container matColumnDef="select">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let row">
        <mat-checkbox
          (change)="$event ? selection.toggle(row) : null"
          [checked]="selection.isSelected(row)"
          >
        </mat-checkbox>
      </td>
    </ng-container>
    <ng-container matColumnDef="fileName">
      <th mat-header-cell *matHeaderCellDef>bestand</th>
      <td mat-cell *matCellDef="let row">
        @if (row.documentLink.endsWith('pdf')) {
          <mat-icon inline>picture_as_pdf</mat-icon>
          }@if (!row.documentLink.endsWith('pdf')) {
          <mat-icon inline>add_a_photo</mat-icon>
        }
        {{ row.fileName }}
      </td>
    </ng-container>
    <ng-container matColumnDef="dateAdded">
      <th mat-header-cell *matHeaderCellDef mat-sort-header disableClear>
        geplaatst
      </th>
      <td mat-cell *matCellDef="let row">
        {{ row.dateAdded | amTimeAgo }}
      </td>
    </ng-container>
    <ng-container matColumnDef="download">
      <th mat-header-cell *matHeaderCellDef>download</th>
      <td mat-cell *matCellDef="let row">
        <a
          mat-icon-button
          download="orca_pdf"
          target="_blank"
          [href]="row.documentLink"
          >
          <mat-icon>get_app</mat-icon>
        </a>
      </td>
    </ng-container>
    <ng-container matColumnDef="delete">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let row">
        <button mat-raised-button (click)="delete(row)" [disabled]="selection.isSelected(row)">Verwijder</button>
      </td>
    </ng-container>
    <!-- Dit is even alleen voor de informatiepagina  ///////// *ngIf="showLink" -->
    <ng-container matColumnDef="downloadLink">
      <th mat-header-cell *matHeaderCellDef>Kopieer de downloadlink en plak het in je tekst</th>
      <td mat-cell *matCellDef="let row">
        <button mat-raised-button (click)="copy(row)">Kopieer</button>
      </td>
    </ng-container>
    <tr
      mat-header-row *matHeaderRowDef="columns"
    ></tr>
    <tr mat-row *matRowDef="let row; columns: columns"></tr>
  </table>
  <mat-paginator [length]="resultsLength" [pageSize]="10"></mat-paginator>
</div>

<input
  type="file"
  (change)="fileChanged($event)"
  accept="image/jpeg,image/gif,image/png,application/pdf"
  #fileInput
  style="display: none"
  />

  @if (selection.hasValue()) {
    <p>
      {{ selection.selected.length }} Bestanden geselecteerd
    </p>
  }
